import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { RecentDealsState } from '../types';

export const recentDealsInitialState = {
    deals: [],
    showRecentDeals: false,
    errorDetails: undefined,
    requestStatus: ApiRequestStatus.Idle
} as RecentDealsState;
